module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/resume.json
// module id = 469
// module chunks = 218357007423260